import { render } from "./HepaticsHeader.vue?vue&type=template&id=075c073c"
import script from "./HepaticsHeader.vue?vue&type=script&lang=js"
export * from "./HepaticsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__